/**
 * Intellectual Property (IP) crossover names
 * Maps internal IP IDs to display-friendly names
 */

export const IP_NAMES: Record<string, string> = {
  walking_dead: "Walking Dead",
  stranger_things: "Stranger Things",
  transformers: "Transformers",
  street_fighter: "Street Fighter",
  fortnite: "Fortnite",
  jurassic_world: "Jurassic World",
  doctor_who: "Doctor Who",
  warhammer_40k: "Warhammer 40K",
  lord_of_the_rings: "Lord of the Rings",
  final_fantasy: "Final Fantasy",
  fallout: "Fallout",
  godzilla: "Godzilla",
  monty_python: "Monty Python",
  princess_bride: "Princess Bride",
  magic_original: "Classic Magic",
};
